import * as React from 'react';

import { t } from 'utils/language';

import TabsUnderlined from 'components/tabs/tabs-underlined/TabsUnderlined';

import type { SyntheticEvent } from 'react';

type Props = {
  value: string,
  onChange: (a: string) => void
};

class InfluencerCampaignHistorySorting extends React.PureComponent<Props> {
  handleSortingClick = (event: SyntheticEvent<HTMLElement>): void => {
    const { onChange, value } = this.props;
    const target = event.currentTarget;
    const option = target.dataset.arg;

    if (!option || option === value) {
      return;
    }

    onChange(option);
  };

  render(): React.ReactNode {
    const { value } = this.props;

    const tabItems = ['newest', 'oldest']
      .map(option => ({
        handleClick: this.handleSortingClick,
        handleClickArg: option,
        label: t(`influencer_campaign_history.sorting_option_${option}`),
        isActive: value === option
      }));

    return (
      <section className="influencer-campaign-history-sorting">
        <span>
          {t('influencer_campaign_history.sort_by_label')}:
        </span>
        <div className="influencer-campaign-history-sorting__tabs">
          <TabsUnderlined
            items={tabItems}
          />
        </div>
      </section>
    );
  }
}

export default InfluencerCampaignHistorySorting;
